<template>
    <div class="main" v-if="!loading">

        <c-panel> 
            <el-row :gutter="10">
                <el-col :xs="24" :sm="24" :md="24">
                    <label>Instituição</label>
                    <el-select v-model="instituicao_id" filterable @change="selectIntituicao()">
                        <el-option v-for="(item, i) in $store.state.instituicoes" :key="i" :label="item.nome" :value="item.id"> </el-option>
                    </el-select>
                </el-col>
            </el-row>
        </c-panel>
        
        <template v-if="instituicao_id">           
                
                <c-panel > 
                    <el-upload
                        ref="upload"
                        action=""
                        accept=".txt"
                        :auto-upload="false"
                        :show-file-list="false"
                        :on-change="onFileChange">

                        <el-button type="primary">
                            Selecionar arquivo
                        </el-button>

                    </el-upload>

                    <span v-if="fileName" style="margin-left:10px;">{{ fileName }}</span>

                    <div style="margin-top:10px;">
                    <el-button
                        type="success"
                        :disabled="!file"
                        @click="uploadFile">

                        Fazer Upload
                    </el-button>

                    <el-button
                        v-if="file"
                        type="danger"
                        @click="removeFile">

                        Remover
                    </el-button>
                    </div>                   
                    
                </c-panel>              
        </template>
    </div>
</template>
<script>

export default {    
    data () {
        return {
            instituicao_id: '',
            loading: false,
            file: null,
            fileName: '',
            maxBytes: 1024 * 1024  // 1MB
        }
    },
    methods:{
        selectIntituicao(){            
            
        }, 
         onFileChange(e){

            if(!e.raw)
                return

            if(e.raw.type !== 'text/plain'){
                this.$message.error('Apenas arquivos .txt são permitidos')
                return
            }

            if(this.maxBytes && e.raw.size > this.maxBytes){
                this.$message.error('Arquivo ultrapassou o tamanho máximo')
                return
            }

            this.file = e.raw
            this.fileName = e.raw.name

        },
        removeFile(){
            this.file = null
            this.fileName = ''
        },       
        async uploadFile(){

            if(!this.file) {
                return;
            }

            try {

                const formData = new FormData()

                formData.append('file', this.file)
                formData.append('instituicao_id', this.instituicao_id)                

                let response = await this.$axios.post(
                    `${this.$store.state.config.baseUrlApi}/api/educacenso/import-inep`,
                    formData,
                    {
                        headers: {
                            ...this.$store.getters.getHeaderAuth.headers,
                            'Content-Type': 'multipart/form-data'
                        }
                    }
                )

                this.$message.success('Upload realizado com sucesso')

                console.log(response);                

                this.removeFile()
                
            }catch(e) {
                this.$message.error('Erro ao enviar arquivo')
                console.error(e);
            }    
        }
    }    
}
</script>
<style>

   .ss-file-uploader .el-upload {
        border: 1px dashed #d9d9d9;
        border-radius: 6px;
        cursor: pointer;
        height: 105px;
        display: flex;
        justify-content: center;
        align-items: center;
    }

    .ss-file-uploader-icon {
        font-size: 28px;
        color: #8c939d;
    }

    .caixa-remove i{
        cursor:pointer; 
        position: absolute; 
        right: 5px; 
        top: 4px; 
        font-size: 15px; 
        color: #000;
    }

</style>